export const wlDatas = {
  attributes: {
    campanha_default: 'LP - (Re) Energisa',
    empresa: 'ENERGISA',
    bg_color: null,
    cor_hover_botao_icon: '#B3BD33',
    usar_configuracao_padrao: false,
    steps_contratacao_pf: [
      {
        name: 'Dados Pessoais',
        index: '1',
      },
      {
        name: 'Endereço',
        index: '2',
      },
      {
        name: 'Identificação',
        index: '3',
      },
      {
        name: 'Conta de luz',
        index: '4',
      },
      {
        name: 'Confirmação',
        index: '5',
      },
      {
        name: 'Assinatura de Contrato',
        index: '6',
      },
    ],
    steps_contratacao_pj: [
      {
        name: 'Dados da empresa',
        index: '1',
      },
      {
        name: 'Identificação',
        index: '2',
      },
      {
        name: 'Conta de luz',
        index: '3',
      },
      {
        name: 'Confirmação',
        index: '4',
      },
      {
        name: 'Assinatura de Contrato',
        index: '5',
      },
    ],
    steps_contratacao_ml: [
      {
        name: 'Dados da empresa',
        index: '1',
      },
      {
        name: 'Identificação',
        index: '2',
      },
      {
        name: 'Assinatura de contrato',
        index: '3',
      },
    ],
    steps_dashboard_pf: [
      {
        name: 'Usina selecionada',
        index: '1',
      },
      {
        name: 'Contrato submetido para análise',
        index: '2',
      },
      {
        name: 'Contrato assinado com a usina',
        index: '3',
      },
      {
        name: 'Seu desconto chegou!',
        index: '4',
      },
    ],
    steps_dashboard_pj: [
      {
        name: 'Usina selecionada',
        index: '1',
      },
      {
        name: 'Contrato submetido para análise',
        index: '2',
      },
      {
        name: 'Contrato assinado com a usina',
        index: '3',
      },
      {
        name: 'Seu desconto chegou!',
        index: '4',
      },
    ],
    steps_dashboard_ml: [
      {
        name: 'Contato comercial',
        index: '1',
      },
      {
        name: 'Seleção de comercializadora ',
        index: '2',
      },
      {
        name: 'Envio de documentos e assinatura de contrato',
        index: '3',
      },
      {
        name: 'Assinatura de contrato com a comercializadora',
        index: '4',
      },
      {
        name: 'Desconto ativo',
        index: '5',
      },
    ],
    config_campos_pipefy_data: {
      nome: 'nome',
      sobrenome: 'sobrenome',
      email: 'email',
      celular: 'n_mero_de_telefone',
      municipio: 'cidade',
      estado: 'estado',
      estado_combo: 'estados_combobox',
      tipo_conta: 'para_sua_casa_ou_para_seu_neg_cio_2',
      valor_medio_mensal_da_conta: 'valor_m_dio_mensal_na_conta_de_luz',
      representante: 'campanha',// Campanha que o lead foi capturado
      assessor: 'acessores',// Responsável pelo lead na campanha - opcional
      clique_ver_ofertas_disponiveis: 'clique_cta_ver_ofertas_dispon_veis',
      economia_estimada: 'economia_estimada',
      concessionaria_pipe: 'concessionaria',// ID DA CONCESSIONARIA NO PIPEFY
      usina_ofertada_pipe: 'geradora_escolhida',// ID DO GERADOR NO PIPEFY
      clique_cta_usina_listing_pipe: 'geradora_listing',// ID DO GERADOR NO PIPEFY
      clique_cta1_card_usina_pipe: 'clicou_cta_1_geradora',// ID DO GERADOR NO PIPEFY
      clique_cta2_card_usina_pipe: 'clicou_cta_2_geradora',// ID DO GERADOR NO PIPEFY

      disponibilidade_atendimento: 'disponibilidade_atendimento',// Sim, Não
      nome_concessionaria: 'concessionaria_new',// RECEBE O NOME DA CONCESSIONARIA SELECIONADA
      nome_usina_ofertada: 'lista_1',// RECEBE O NOME DA USINA SELECIONADA
      nome_concessionaria_txt: 'concessionaria_txt_1',// RECEBE O NOME DA CONCESSIONARIA SELECIONADA PARA BKP
      nome_usina_ofertada_txt: 'geradora_txt_1',// RECEBE O NOME DA USINA SELECIONADA PARA BKP
      clique_cta_usina_listing_nome: 'geradora_listing_new',// RECEBE O LIST COM NOME DA USINA SELECIONADA
      clique_cta1_card_usina_listing_nome: 'clique_cta1_card_geradora_new',// RECEBE O LIST COM NOME DA USINA SELECIONADA
      clique_cta2_card_usina_listing_nome: 'copy_of_clique_cta1_card_geradora_new',// RECEBE O LIST COM NOME DA USINA SELECIONADA
      
      clique_cta_solicitar_ml: 'fale_com_nosso_time',
      mercado_livre: 'cliente_mercado_livre',
      nome_contrato: 'nome_contrato',
      cnpj: 'cnpj',
      cpf: 'cpf',
      cep: 'cep',
      endereco_rua: 'rua',
      complemento: 'complemento',
      numero: 'n_mero',
      completou_fluxo: 'completou_o_fluxo',
      engajamento_com_proposta_de_valor: 'engajamento_com_proposta_de_valor',
      logou_na_plataforma: 'clicou_cta_entrar',
      clique_cta_continuar1_ml: 'clicou_cta_1_de_ml_continuar',
      clique_cta_continuar2_ml: 'clicou_cta_2_de_ml_continuar',
      conta_de_luz_enviada: 'conta_de_luz_enviada',
      codigo_validado: 'c_digo_validado',
      confirmacao_dados: 'confirma_o_de_dados',
      origem_api: 'origem_api',
    },
    config_campos_sharpspring: {
      cep: 'cep_64ecac25b432a',
      cpf: 'cpf_cnpj_64ecab788aa2a',
      kwh: 'kwh_64ecabc90f2d5',
      city: 'city',
      cnpj: 'cnpj_64ed0b76d3cf8',
      nome_contrato: '',
      email: 'emailAddress',
      state: 'state',
      title: 'title',
      active: 'active',
      estado: 'estado_64ecabf0dc66b',
      numero: 'n__mero_64ed0c1e4ecb7',
      status: 'status',
      street: 'street',
      celular: 'phoneNumber',
      country: 'country',
      ownerID: 'ownerID',
      persona: 'persona',
      website: 'website',
      zipcode: 'zipcode',
      industry: 'industry',
      pessoa_f: 'pessoa_f__sica_jur__dica__64ecabb7057a8',
      accountID: 'accountID',
      faxNumber: 'faxNumber',
      firstName: 'firstName',
      isContact: 'isContact',
      leadScore: 'leadScore',
      municipio: 'munic__pio_64ecab4e528ec',
      campaignID: 'campaignID',
      isCustomer: 'isCustomer',
      leadStatus: 'leadStatus',
      pessoa_jur: 'pessoa_jur__dica__64ed0d214e17a',
      trackingID: 'trackingID',
      companyName: 'companyName',
      complemento: 'complemento_64ed0acf59bb4',
      description: 'description',
      isQualified: 'isQualified',
      emailAddress: 'emailAddress',
      endereco_rua: 'endere__o_64ecabd4cfd83',
      lista_espera: '',
      mercado_livre: '',
      concessionaria: 'concession__ria_64ed0b1a57f70',
      isUnsubscribed: 'isUnsubscribed',
      url_identidade: 'documento_de_identifica____o_64ecaacb276a0',
      usina_ofertada: 'usina_ofertada_64ed0cccb91b8',
      completou_fluxo: 'completou_o_fluxo_64ecaa9d5e6db',
      consumo_de_pico: '',
      createTimestamp: 'createTimestamp',
      periodo_de_pico: 'per__odo_de_pico_64ed0c33e125d',
      tipo_de_moradia: '',
      updateTimestamp: 'updateTimestamp',
      url_conta_de_luz: 'conta_de_luz_64ecaabd9721f',
      economia_estimada: 'economia_estimada_64ed0bb32812a',
      leadScoreWeighted: 'leadScoreWeighted',
      mobilePhoneNumber: 'mobilePhoneNumber',
      logou_na_plataforma: 'logou_na_plataforma__64ecab082dbad',
      municipio_uf_espera: '',
      onboarding_1_submit: 'onboarding_1_submit_64ef337a12423',
      onboarding_2_submit: 'onboarding_2_submit_64ef33910f1ca',
      onboarding_3_submit: 'onboarding_3_submit_64ef33a6a9274',
      onboarding_4_submit: 'onboarding_4_submit_64ef33bc9734a',
      onboarding_5_submit: 'onboarding_5_submit_64ef33d470745',
      onboarding_6_submit: 'onboarding_6_submit_64ef33e9f15a8',
      unidade_consumidora: '',
      url_contrato_social: 'contrato_social_64ecaad8492b1',
      conta_de_luz_enviada: '',
      ml_contrato_assinado: '',
      phoneNumberExtension: 'phoneNumberExtension',
      clique_cta1_card_usina: 'clique_cta_1_card_usina_64ecaa29e4d65',
      clique_cta2_card_usina: 'clique_cta_2_card_usina_64ecaa52302da',
      clique_cta_solicitar_ml: 'clique_cta_solicitar_contato_ml_64ef358d73544',
      clique_cta_continuar1_ml: 'clique_cta_continuar1_ml_64ef361c9bcf5',
      clique_cta_continuar2_ml: 'clique_cta_continuar2_ml_64ef35bc6e804',
      clique_cta_usina_listing: 'clique_cta_usina_listing_64eca9f82c82d',
      quantos_residentes_na_casa: '',
      clique_cta_ver_propostas_ml: '',
      disponibilidade_atendimento: 'disponibilidade_atendimento__64ed0b9640692',
      valor_medio_mensal_da_conta: 'valor_m__dio_mensal_da_conta_64eca9611c8df',
      clique_ver_ofertas_disponiveis:
        'clique_cta_ver_ofertas_dispon__veis_64ecaa85186c6',
      engajamento_com_proposta_de_valor: '',
    },
    bg_color_frame: null,
    cor_tema_primaria: '#009BBE',
    cor_tema_secundaria: '#C3CD3C',
    cor_tema_3: '#CCEBF2',
    cor_tema_4: '#CCEBF2',
    cor_tema_5: '#009BBE',
    cor_tema_botao_solido: '#c3cd3c',
    cor_texto_botao: '#000000',
    cor_tema_botao_desabilitado: '#EDF0C5',
    botao_gradiente: null,
    cor_botao_icone: '#c3cd3c',
    cor_tema_botao_borda: '#009bbe',
    cor_hover_botao_borda: '#ccebf2',
    cor_tema_step_default: '#009BBE',
    cor_ponta_inferior_lateral_esquerda: '#0083B1',
    consentimento_cookie_text:
      'Armazenamos cookies para melhorar sua experiência de navegação. Conheca nossa [[Política de Privacidade]]',
    code_tag_manager: '54B6FBNB',
    logo_empresa: {
      data: {
        attributes: {
          url: '/wl/reenergisa/logo_empresa.svg',
        },
      },
    },
    logo_empresa_2: {
      data: {
        attributes: {
          url: '/wl/reenergisa/logo_empresa_2.svg',
        },
      },
    },
    logo_empresa_rodape: {
      data: {
        attributes: {
          url: '/wl/reenergisa/logo_empresa_rodape.svg',
        },
      },
    },
    favicon: {
      data: {
        attributes: {
          url: '/wl/reenergisa/favicon.png',
        },
      },
    },
    bg_img_frame: {
      data: null,
    },
    splash: {
      data: {
        attributes: {
          url: '/wl/reenergisa/splash.gif',
        },
      },
    },
    card_esquerda: {
      data: {
        attributes: {
          url: '/wl/reenergisa/card_esquerda.svg',
        },
      },
    },
    bg_img_redirect: {
      data: null,
    },
    icone_whatsapp: {
      data: {
        attributes: {
          url: '/wl/reenergisa/icone_whatsapp.png',
        },
      },
    },
    icone_duvidas: {
      data: {
        attributes: {
          url: '/wl/reenergisa/icone_duvidas.png',
        },
      },
    },
    bg_img_manutencao: {
      data: {
        attributes: {
          url: '/wl/reenergisa/bg_img_manutencao.png',
        },
      },
    },
    bg_img_error_aplicacao: {
      data: {
        attributes: {
          url: '/wl/reenergisa/bg_img_error_aplicacao.png',
        },
      },
    },
    Onboarding: {
      header_color: true,
      titulo_bem_vindo: 'Bem vindo a (re)energisa!',
      titulo_onboarding_1: 'Por que a (re)energisa?',
      descricao_onboarding_1:
        'Você vai conhecer um novo jeito de consumir energia: mais barata, mais sustentável, com mais liberdade de escolha e facilidade!',
      titulo_onboarding_2: ' Energia na palma da sua mão',
      descricao_onboarding_2:
        'Escolha a usina parceira e o tipo de energia que irá consumir na sua casa.  Economize na conta de luz e tenha uma atitude sustentável.  ',
      titulo_onboarding_3: 'Muito simples e seguro ',
      descricao_onboarding_3:
        'A contratação é simples e segura. E não se preocupe com falta de luz, pois você continuará ligado ao fornecimento tradicional de energia.',
      titulo_onboarding_4: 'Escolha o melhor para você ',
      descricao_onboarding_4:
        'Informe o seu consumo. A gente apresenta as possibilidades. Você assina o contrato e nós avisamos à usina e a sua distribuidora. ',
      titulo_onboarding_5: 'Economia o ano inteiro ',
      descricao_onboarding_5:
        'No final do ciclo de consumo, você vai passar a pagar duas contas mas, o valor total será até 25% menor do que aquele que você paga hoje. ',
      titulo_onboarding_6: 'Faça sua escolha',
      descricao_onboarding_6:
        'Chega de pagar caro por energia elétrica! Seja sustentável e economize. \nBora começar essa mudança?',
      background_img: null,
      bg_img_onboarding_1: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_onboarding_1.png',
          },
        },
      },
      bg_img_onboarding_2: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_onboarding_2.png',
          },
        },
      },
      bg_img_onboarding_3: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_onboarding_3.png',
          },
        },
      },
      bg_img_onboarding_4: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_onboarding_4.png',
          },
        },
      },
      bg_img_onboarding_5: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_onboarding_5.png',
          },
        },
      },
      bg_img_onboarding_6: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_onboarding_6.png',
          },
        },
      },
    },
    Usuario: {
      bg_img_confirmacao_conta: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_confirmacao_conta.png',
          },
        },
      },
      bg_img_email_enviado: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_email_enviado.png',
          },
        },
      },
      bg_img_erro_link_invalido: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_erro_link_invalido.png',
          },
        },
      },
      bg_img_password_reset: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_password_reset.png',
          },
        },
      },
      bg_img_password_reset_success: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_password_reset_success.png',
          },
        },
      },
      bg_img_reenviar_email: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_reenviar_email.png',
          },
        },
      },
      bg_img_sem_conta: {
        data: {
          attributes: {
            url: "/wl/reenergisa/bg_img_sem_conta.png",
          },
        },
      },
    },
    Calculadora: {
      cor_botao_select: '#009bbe',
      texto_descricao_consumo: 'Quanto sua empresa gasta com luz por mês?',
      cor_hover_botao_icon: '#CCEBF2',
      habilitar_contrato_pf: false,
      habilitar_contrato_pj: true,
      habilitar_captura_fornecedor: true,
      texto_captura_fornecedor: 'Seja um gerador parceiro (re)energisa!',
      bg_img_calculadora_success: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_calculadora_success.png',
          },
        },
      },
      bg_img_calculadora_not_found: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_calculadora_not_found.png',
          },
        },
      },
      titulo_sem_estoque:
        'Ah, que pena! A energia esgotou na sua região, devido a alta demanda.',
      descricao_sem_estoque:
        'Estamos trabalhando para ampliar a oferta de energia limpa e oferecê-la novamente em sua região. Não desanime! Enquanto isso, você está em nossa lista de espera e vamos te mantendo atualizado de todas as novidades da (re)energisa.',
      img_sem_estoque: {
        data: {
          attributes: {
            url: '/wl/reenergisa/img_sem_estoque.png',
          },
        },
      },
      titulo_nao_atendida: 'Ah, que pena! Ainda não atendemos a sua região.',
      descricao_nao_atendida:
        'Estamos trabalhando para em breve, oferecer energia limpa e mais em conta para você e todo Brasil. Enquanto isso, vamos te mantendo atualizado de todas as novidades da (re)energisa.',
      img_nao_atendida: {
        data: {
          attributes: {
            url: '/wl/reenergisa/img_nao_atendida.png',
          },
        },
      },
      img_form_fornecedor: {
        data: {
          attributes: {
            url: '/wl/reenergisa/img_form_fornecedor.png',
          },
        },
      },
      img_sem_consumo_minimo: {
        data: null,
      },
    },
    Coleta_Dados_Usuario: {
      bg_img_code_sms: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_code_sms.png',
          },
        },
      },
      bg_img_confirmacao_dados_confirmacao_sms: {
        data: null,
      },
      bg_img_localizacao: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_localizacao.png',
          },
        },
      },
      bg_img_localizacao_nao_encontrado: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_localizacao_nao_encontrado.png',
          },
        },
      },
    },
    Formulario: {
      bg_img_form: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_form.png',
          },
        },
      },
      bg_img_form_confirmacao: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_form_confirmacao.png',
          },
        },
      },
      bg_img_tooltip_form: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_tooltip_form.png',
          },
        },
      },
    },
    Pessoa_Fisica: {
      Step_1: {
        bg_img_dados_nao_encontrados: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_dados_nao_encontrados.png',
            },
          },
        },
        bg_img_dados_pessoais: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_dados_pessoais.png',
            },
          },
        },
      },
      Step_2: {
        bg_img_confirme_dados_endereco: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_confirme_dados_endereco.png',
            },
          },
        },
        bg_img_endereco: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_endereco.png',
            },
          },
        },
      },
      Step_3: {
        bg_img_rg: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_rg.png',
            },
          },
        },
        bg_img_tooltip_rg: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_tooltip_rg.png',
            },
          },
        },
        bg_img_documento_adicionado: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_documento_adicionado.png',
            },
          },
        },
      },
      Step_4: {
        bg_img_conta_luz: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_conta_luz.png',
            },
          },
        },
        bg_img_tooltip_conta_luz: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_tooltip_conta_luz.png',
            },
          },
        },
        bg_img_conta_luz_adicionada: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_conta_luz_adicionada.png',
            },
          },
        },
      },
      Step_5: {
        bg_img_confirmacao_conta: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_confirmacao_conta.png',
            },
          },
        },
      },
    },
    Pessoa_Juridica: {
      Step_1_pj: {
        bg_img_contrado_social_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_contrado_social_pj.png',
            },
          },
        },
        bg_img_tooltip_contrado_social_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_tooltip_contrado_social_pj.png',
            },
          },
        },
        bg_img_vamos_comecar_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_vamos_comecar_pj.png',
            },
          },
        },
        bg_img_dados_empresa_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_dados_empresa_pj.png',
            },
          },
        },
        bg_img_contrado_social_adicionado_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_contrado_social_adicionado_pj.png',
            },
          },
        },
        bg_img_confirme_dados_empresa_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_confirme_dados_empresa_pj.png',
            },
          },
        },
        bg_img_possui_demanda_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_possui_demanda_pj.png',
            },
          },
        },
        bg_img_tooltip_possui_demanda_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_tooltip_possui_demanda_pj.png',
            },
          },
        },
      },
      Step_2_pj: {
        bg_img_rg_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_rg_pj.png',
            },
          },
        },
        bg_img_tooltip_rg_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_tooltip_rg_pj.png',
            },
          },
        },
      },
      Step_3_pj: {
        bg_img_conta_luz_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_conta_luz_pj.png',
            },
          },
        },
        bg_img_tooltip_conta_luz_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_tooltip_conta_luz_pj.png',
            },
          },
        },
        bg_img_conta_luz_adicionada_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_conta_luz_adicionada_pj.png',
            },
          },
        },
      },
      Step_4_pj: {
        bg_img_dados_submetidos_pj: {
          data: {
            attributes: {
              url: '/wl/reenergisa/bg_img_dados_submetidos_pj.png',
            },
          },
        },
      },
    },
    Email: {
      bg_img_confirmacao_conta: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_email_confirmacao_conta.svg',
          },
        },
      },
      bg_img_contrato_assinado: {
        data: {
          attributes: {
            url: '/wl/ELECTY/img_contrato_assinado.svg',
          },
        },
      },
    },
    Mercado_Livre: {
      bg_img_sucesso_solicitacao_contato: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_sucesso_solicitacao_contato.png',
          },
        },
      },
      bg_img_conta_luz_ml: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_conta_luz_ml.png',
          },
        },
      },
      bg_img_tooltip_conta_luz_ml: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_tooltip_conta_luz_ml.png',
          },
        },
      },
      bg_img_conta_luz_adicionada_ml: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_conta_luz_adicionada_ml.png',
          },
        },
      },
      entenda_porque_1: {
        data: {
          attributes: {
            url: '/wl/reenergisa/entenda_porque_1.png',
          },
        },
      },
      bg_img_contrato_social_adicionado_ml: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_contrato_social_adicionado_ml.png',
          },
        },
      },
      bg_img_documento_adicionado_ml: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_documento_adicionado_ml.png',
          },
        },
      },
      bg_img_contrato_social_ml: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_contrato_social_ml.png',
          },
        },
      },
      bg_img_tooltip_contrado_social: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_tooltip_contrado_social.png',
          },
        },
      },
      bg_img_tooltip_documento_ml: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_tooltip_documento_ml.png',
          },
        },
      },
      bg_img_documento_ml: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_documento_ml.png',
          },
        },
      },
    },
    Zapsign: {
      bg_img_assinatura_contrato: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_assinatura_contrato.png',
          },
        },
      },
      bg_img_contrato_assinado: {
        data: {
          attributes: {
            url: '/wl/reenergisa/bg_img_contrato_assinado.png',
          },
        },
      },
    },
  },
};
